"use strict";
import "regenerator-runtime/runtime";

export const booklist = (function () {
    const init = function () {
        const booklistElement = document.querySelector(".booklist");
        const filterLinks = document.querySelectorAll(".filterLinks a");
        const tocLinks = document.querySelectorAll(".filters a");

        // When a filter link is clicked, send an AJAX request to the server to get the filtered book list.
        tocLinks.forEach((link) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();

                const url = e.target.href;
                const slug = e.target.getAttribute("data-slug");

                // Update the selected class to the filter link based on data-slug attribute
                updateFilterToc(slug);

                showSpinner(slug);

                fetchBookPage(url).then((response) => {
                    booklistElement.innerHTML = response;

                    // Update the browser URL to reflect the current filter
                    window.history.pushState("", "", url);

                    hideSpinner();
                });
            });
        });

        // When a tag links is clicked, send an AJAX request to the server to get the filtered book list.
        booklistElement.addEventListener("click", function (e) {
            if (e.target.matches(".filterLinks a")) {
                // When a filter link is clicked, override the default behavior and instead send an AJAX request to the server
                // to get the filtered book list.
                e.preventDefault();

                const url = e.target.href;
                const slug = e.target.getAttribute("data-slug");

                // Update the selected class to the filter link based on data-slug attribute
                updateFilterToc(slug);

                showSpinner(slug);

                fetchBookPage(url).then((response) => {
                    booklistElement.innerHTML = response;

                    // Update the browser URL to reflect the current filter
                    window.history.pushState("", "", url);

                    hideSpinner();
                });
            }
        });

        // When the back or forward button is clicked, update the book list based on the URL
        window.addEventListener("popstate", (e) => {
            const url = window.location.href;

            // Update the selected class to the filter link based on data-slug attribute
            // Remove trailing slash from url
            const urlNoTrailingSlash = url.replace(/\/$/, "");
            const slug = urlNoTrailingSlash.split("/").pop();
            updateFilterToc(slug);

            showSpinner(slug);

            fetchBookPage(url).then((response) => {
                booklistElement.innerHTML = response;

                hideSpinner();
            });
        });
    };

    function updateFilterToc(newSlug) {
        const tocLinks = document.querySelectorAll(".filters a");
        tocLinks.forEach((link) => {
            if (link.getAttribute("data-slug") === newSlug) {
                link.classList.add("selected");
            } else {
                link.classList.remove("selected");
            }
        });

        // If slug is book-nook, add selected class to the first filter link
        if (newSlug === "book-nook") {
            tocLinks[0].classList.add("selected");
        }
    }

    function showSpinner(slug) {
        const tocLinks = document.querySelectorAll(".filters a");
        tocLinks.forEach((link) => {
            if (link.getAttribute("data-slug") === slug) {
                link.classList.add("loading");
            }
        });
    }

    function hideSpinner() {
        const tocLinks = document.querySelectorAll(".filters a");
        tocLinks.forEach((link) => {
            link.classList.remove("loading");
        });
    }

    async function fetchBookPage(url) {
        // TESTING: wait for a bit
        await new Promise((resolve) => setTimeout(resolve, 1500));

        // Get the book list page using fetch
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const booklist = doc.querySelector(".booklist");
        return booklist.innerHTML;
    }

    return { init };
})();
